import React, { useMemo, useState, useCallback } from 'react'
import * as THREE from 'three'
import { useFrame, useLoader } from 'react-three-fiber'
import { Plane, Html } from 'drei'
import { PlainAnimator } from 'three-plain-animator/lib/plain-animator'
import useInterval from '@use-it/interval'
// import { useControl } from 'react-three-gui'
// import useStore from '../../store'
import { getRandonInt } from '../../helpers/numbers'
import { IS_PRODUCTION } from '../../config'
import objects from '../../config/objects.json'

const FORCE_POSITIONING = false
const POSITIONING = IS_PRODUCTION ? false : FORCE_POSITIONING

const lightningsConfig = [
  { totalFrames: 6, url: '/assets/images/lightnings/1.png' },
  { totalFrames: 6, url: '/assets/images/lightnings/2.png' },
  { totalFrames: 7, url: '/assets/images/lightnings/3.png' },
  { totalFrames: 6, url: '/assets/images/lightnings/4.png' },
  { totalFrames: 7, url: '/assets/images/lightnings/5.png' },
  { totalFrames: 8, url: '/assets/images/lightnings/6.png' },
  { totalFrames: 8, url: '/assets/images/lightnings/7.png' },
  { totalFrames: 8, url: '/assets/images/lightnings/8.png' },
  { totalFrames: 6, url: '/assets/images/lightnings/9.png' },
  { totalFrames: 6, url: '/assets/images/lightnings/10.png' },
  { totalFrames: 7, url: '/assets/images/lightnings/11.png' },
  { totalFrames: 6, url: '/assets/images/lightnings/12.png' },
  { totalFrames: 7, url: '/assets/images/lightnings/13.png' },
  { totalFrames: 8, url: '/assets/images/lightnings/14.png' },
  { totalFrames: 8, url: '/assets/images/lightnings/15.png' },
  { totalFrames: 8, url: '/assets/images/lightnings/16.png' },
]
const urls = lightningsConfig.map((cfg) => cfg.url)
const maxIndex = lightningsConfig.length - 1

const LightningRender = ({ texture, totalFrames }) => {
  const animator = useMemo(() => (
    new PlainAnimator(texture, totalFrames, 1, totalFrames, 15)
  ), [texture, totalFrames])

  const animatedTexture = useMemo(() => animator.init(), [animator])

  useFrame(() => animator.animate())

  return (
    <meshPhongMaterial
      transparent={!POSITIONING}
      attach="material"
      map={animatedTexture}
      side={THREE.DoubleSide}
    />
  )
}

const Lightning = ({ name }) => {
  const lightningsTextures = useLoader(THREE.TextureLoader, urls)
  const [show, setShow] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(getRandonInt(0, maxIndex))
  const [interval, changeInterval] = useState(getRandonInt(20000, 60000))
  // const setTransforms = useStore((state) => state.setTransforms)

  const config = useMemo(() => objects[name], [name])

  const onShow = useCallback(() => {
    setShow(true)
    changeInterval(getRandonInt(1000, 4000))
  }, [])

  const onHide = useCallback(() => {
    setShow(false)
    setCurrentIndex(getRandonInt(0, maxIndex))
    changeInterval(getRandonInt(20000, 90000))
  }, [])
  
  useInterval(() => show ? onHide() : onShow(), interval)

  // const posY = useControl('Altura', {
  //   group: name,
  //   type: 'number',
  //   min: -5,
  //   max: 5,
  //   value: config.y || 0,
  //   onChange: (value) => setTransforms({ id: name, key: 'y', value }),
  // })

  // const posX = useControl('Pos X', {
  //   group: name,
  //   type: 'number',
  //   min: -10,
  //   max: 10,
  //   value: config.x || 0,
  //   onChange: (value) => setTransforms({ id: name, key: 'x', value }),
  // })

  // const posZ = useControl('Pos Z', {
  //   group: name,
  //   type: 'number',
  //   min: -10,
  //   max: 10,
  //   value: config.z || 0,
  //   onChange: (value) => setTransforms({ id: name, key: 'z', value }),
  // })

  // const rotation = useControl('Rotação', {
  //   group: name,
  //   type: 'number',
  //   min: 0,
  //   max: 6.3,
  //   value: config.rotate || 0,
  //   onChange: (value) => setTransforms({ id: name, key: 'rotate', value }),
  // })

  // const size = useControl('Tamanho', {
  //   group: name,
  //   type: 'number',
  //   min: 0.1,
  //   max: 20,
  //   value: config.size || 0.5,
  //   onChange: (value) => setTransforms({ id: name, key: 'size', value }),
  // })

  // const args = useMemo(() => ([size, (size * 1.89)]), [size])
  const args = useMemo(() => ([
    config.size * 5,
    (config.size * 1.89) * 15,
  ]), [config.size])

  // if (!show && !POSITIONING) return null
  return (
    <Plane
      args={args}
      position={[config.x, config.y, config.z]}
      // rotation={[0, config.rotation, 0]}
      // visible={show}
      // position={[posX, posY, posZ]}
      rotation={[POSITIONING ? 2 : 0, config.rotate, 0]}
      visible={show || POSITIONING}
    >
      <LightningRender
        texture={lightningsTextures[currentIndex]}
        totalFrames={lightningsConfig[currentIndex].totalFrames}
      />
      {POSITIONING && (
        <Html>
          <p>{name.split(' ')[1]}</p>
        </Html>
      )}
    </Plane>
  )
}


const Lightnings = () => {
  return (
    <>
      <Lightning name="Lightning 1" />
      <Lightning name="Lightning 2" />
      <Lightning name="Lightning 3" />
      <Lightning name="Lightning 4" />
      <Lightning name="Lightning 5" />
      <Lightning name="Lightning 6" />
      <Lightning name="Lightning 7" />
      <Lightning name="Lightning 8" />
      <Lightning name="Lightning 9" />
      <Lightning name="Lightning 10" />
      <Lightning name="Lightning 11" />
      <Lightning name="Lightning 12" />
      <Lightning name="Lightning 13" />
      <Lightning name="Lightning 14" />
      <Lightning name="Lightning 15" />
      {/* <Lightning name="Lightning 16" />
      <Lightning name="Lightning 17" />
      <Lightning name="Lightning 18" />
      <Lightning name="Lightning 19" />
      <Lightning name="Lightning 20" /> */}
    </>
  )
}

export default Lightnings
